module.exports = __webpack_public_path__ + "static/spotify-9d1ab9790949ea9ecd560e9f490fd157.png";